
import { Component, Watch, Prop, VModel } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'

import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import ProjectMixin from '@/_mixins/project'
import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    mixins: [ObservationMixin, ProjectMixin],
    components: { DialogTemplate },
})
export default class TreeitemDialog extends Mixins<MixinInterface>(ObservationMixin, ProjectMixin) {
    @VModel() dialog!: boolean
    @Prop({ required: true }) item!: null | Record<string, any> | Array<any>
    @Prop({ required: true }) itemType!: string
    @Prop({ required: true }) flatItems!: Array<any>
    @Prop({ required: true }) projectId!: string
    @Prop({ default: false }) returnObject!: string
    @Prop({ default: false }) allowArchived!: boolean
    @Prop({ default: false }) hasIsNullOption!: boolean
    @Prop({ default: false }) isNull!: boolean

    loading = true
    searchTerm = ''
    localFilters = [] as null | Record<string, any> | Array<any>

    isDisabled(item) {
        return !this.allowArchived && !item.isActive
    }

    get flatItemsFormated() {
        return this.flatItems.map((item) => {
            item.disabled = !this.allowArchived && !item.isActive
            return item
        })
    }

    get itemsTree() {
        return this.unflattenArray(this.flatItemsFormated, undefined)
    }

    singleValueComparator(selectedVal: any, item: any) {
        return selectedVal?.id == item.id
    }

    selectFilters() {
        if (!this.returnObject) {
            if (this.lodash.isArray(this.localFilters)) {
                this.$emit(
                    'selectItems',
                    this.localFilters.map((val) => val.id)
                )
            } else {
                this.$emit('selectItems', this.localFilters ? this.localFilters.id : null)
            }
        } else {
            this.$emit('selectItems', this.localFilters)
        }

        this.$emit('setisNull', this.isNullLocal)

        this.dialog = false
    }

    // IsNull (filter[treeitem][isNull] and filter[treeitem] do not work together)
    isNullLocal = false

    //If user set isNull to true, FE has to empty the filters array
    @Watch('isNullLocal', { immediate: true })
    handleIsNullLocal() {
        if (this.isNullLocal && this.lodash.isArray(this.localFilters)) {
            this.localFilters = []
        }
    }

    // If user selects any of the items from treeview, isNull option is not valid anymore
    handleLocalFilters() {
        if (this.localFilters?.length > 0) {
            this.isNullLocal = false
        }
    }

    // Nodes control
    openNodes = [] as Array<string> | Array<any>

    initOpenNodes() {
        if (this.lodash.isArray(this.localFilters)) {
            this.localFilters.forEach((item) => {
                if (typeof item == 'string') {
                    this.openNodesById(item)
                } else if (item) {
                    this.openNodesById(item.id)
                }
            })
        } else if (this.localFilters) {
            if (typeof this.localFilters == 'string') {
                this.openNodesById(this.localFilters)
            } else if (this.localFilters) {
                this.openNodesById(this.localFilters.id)
            }
        }
    }

    openNodesById(id: string, firstLevel = true) {
        const item = this.localItems.find((val) => val.id == id)
        const parent = item.parent.data

        if (!firstLevel) {
            if (this.lodash.isArray(this.localFilters)) {
                if (this.openNodes.findIndex((node) => node.id == item.id) == -1) {
                    this.openNodes.push(item)
                }
            } else {
                if (!this.openNodes.includes(item.id)) {
                    this.openNodes.push(item.id)
                }
            }
        }

        if (parent) {
            this.openNodesById(parent.id, false)
        }
    }

    @Debounce(500)
    @Watch('searchTerm')
    openNodesByName() {
        this.openNodes = []

        const filterdItems = this.localItems.filter((val) => {
            return val.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        })

        filterdItems.forEach((item) => {
            this.openNodesById(item.id)
        })
    }

    // Treeview
    localItems = [] as Array<any>
    localItemsTree = [] as Array<any>

    @Watch('dialog')
    async setTreeitems() {
        if (!this.flatItemsFormated || this.flatItemsFormated.length == 0) return

        this.isNullLocal = this.isNull

        let localItems = this.lodash.cloneDeep(this.flatItemsFormated)

        if (this.lodash.isArray(this.item)) {
            this.localFilters = this.lodash.cloneDeep(this.item).map((item) =>
                localItems.find((localItem) => {
                    if (typeof item == 'string') {
                        return localItem.id == item
                    } else {
                        return localItem.id == item.id
                    }
                })
            )
        } else {
            this.localFilters = this.item ? this.lodash.cloneDeep(this.item) : null
        }

        this.localItems = localItems.filter((item) => item.project.data.id == this.projectId)
        this.localItemsTree = this.unflattenArray(this.localItems, undefined)
        this.initOpenNodes()
    }

    async mounted() {
        if (this.flatItemsFormated.length == 0) {
            this.loading = true

            if (this.itemType == 'location') {
                await this.getProjectLocations(null, this.projectId)
            } else if (this.itemType == 'cause') {
                await this.getObservationCauses(null, this.projectId)
            } else if (this.itemType == 'category') {
                await this.getObservationCategories(null, this.projectId)
            }
        }

        this.loading = false

        this.setTreeitems()
    }
}
